<template>
  <PaginaManutencao v-if="manutencao" />
  <div v-else class="background-geral">
    <vAlert :alertas="alertas" />
    <DebugFront v-if="devsLiberados.includes(+getUser.id_usuario)" />
    <ModalFuncionalidades />
    <ModalTermos />
    <ModalUsuarioPro />
    <ModalResumoTecnico :getExibeLp="getExibeLp" />
    <MensagemTela class="mensagem-tela" />
    <div v-if="$route.name != 'Erro'">
      <MenuPrincipal class="no-print" />
      <BannerPrincipal class="no-print" />
    </div>
    <router-view class="router-corpo" />
    <vFooter class="no-print" />
  </div>
</template>

<script>
import vAlert from "@/components/v-alert/v-alert.vue";
import BannerPrincipal from "./BannerPrincipal.vue";
import MensagemTela from "./MensagemTela.vue";
import MenuPrincipal from "@/components/MenuPrincipal/MenuPrincipal.vue";
import vFooter from "@/components/v-footer/v-footer.vue";
import ModalFuncionalidades from "@/components/ModalFuncionalidades/ModalFuncionalidades.vue";
import ModalTermos from "@/components/ModalTermos/ModalTermos.vue";
import ModalResumoTecnico from "@/components/ModalResumoTecnico/ModalResumoTecnico.vue";
import ModalUsuarioPro from "@/components/ModalUsuarioPro/ModalUsuarioPro.vue";
import PaginaManutencao from "@/components/PaginaManutencao/PaginaManutencao.vue";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import DebugFront from "@/components/Desenvolvimento/DebugFront.vue";

import Log from "@/services/log.js";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Preloader",
  components: {
    vAlert,
    BannerPrincipal,
    MenuPrincipal,
    MensagemTela,
    vFooter,
    ModalFuncionalidades,
    ModalTermos,
    ModalResumoTecnico,
    ModalUsuarioPro,
    PaginaManutencao,
    BotaoPadrao,
    DebugFront
  },

  provide() {
    return {
      pushAlert: this.pushAlert
    };
  },
  data() {
    return {
      alertas: [],
      devsLiberados: [117310, 119316]
    };
  },
  async created() {
    if (this.getUser.id_usuario == "38048") {
      this.setUsuarioPro(true);
    }
    
    if (this.$route.name == "RTE") {
      this.$router.push("/");
    }

    if (this.getUsuarioPro && !this.getToken && this.$route.name != "Erro") {
      return;
    }

    if (this.getPrimeiroLogin) {
      this.$root.$emit("bv::show::modal", "ModalTermos");
    }

    await this.fetchCenarios();

    if (this.getExibeLp) {
      this.$root.$emit("bv::show::modal", "ModalResumoTecnico");
      this.setExibeLp(false);
    }
  },
  mounted() {
    if (this.getUsuarioPro && !this.getToken && this.$route.name != "Erro") {
      this.$root.$emit("bv::show::modal", "ModalUsuarioPro");
    }
    // else {
    // reportLogin não está funcionando na api
    // this.reportLogin();
    // }
  },
  computed: {
    ...mapGetters("empresa", ["getListEmpresa"]),
    ...mapGetters("login", ["getUser", "getExibeAviso", "getExibeLp", "getPrimeiroLogin"]),
    ...mapGetters("auth", ["getUsuarioPro", "getToken"]),
    manutencao() {
      // if (this.assinatura_tipo_id != 100 && this.assinatura_tipo_id != 90) {
      //   return true
      // }
      return false;
    }
  },
  methods: {
    ...mapActions("cenario", ["fetchCenarios"]),
    ...mapActions("empresa", ["fetchListaEmpresas"]),
    ...mapActions("login", ["setExibeLp"]),
    ...mapActions("auth", ["setUsuarioPro"]),

    reportLogin() {
      let obj = {
        strIP: this.getUser.ip,
        strAgente: navigator.userAgent,
        strMetodoHttp: "GET",
        intIdUsuario: this.getUser.id_usuario,
        strNomeUsuario: this.getUser.nome_usuario,
        strLogin: this.getUser.email_usuario,
        strSenha: "-",
        blAcessoSistema: true
      };
      new Log().reportLogin(obj);
    },

    pushAlert: function(msg, classe) {
      this.alertas = [];
      this.alertas.push({
        msg: msg,
        class: classe,
        blShow: true
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.router-corpo {
  min-height: calc(100vh - 283px);
  padding-bottom: 15px;
}
.background-geral {
  background: var(--cinza01);
}
.mensagem-tela {
  display: none;
  position: sticky;
  top: 0;
  z-index: 10000000;
}

@media only screen and (max-width: 1000px) {
  .mensagem-tela {
    display: block;
  }
}
</style>
